// client/src/services/userContext.js

/**
 * Get current user information from localStorage
 * 
 * This function retrieves the logged-in user's information from the 'me' object
 * stored in localStorage. It's used throughout the app to get user context.
 * 
 * @returns {Object|null} User object or null if not found
 */
export function getMe() {
  try {
    const meStr = localStorage.getItem('me');
    if (!meStr) {
      return null;
    }
    
    const me = JSON.parse(meStr);
    
    // Ensure we have at least an ID
    if (!me || (!me.id && !me.userid && !me.userId)) {
      return null;
    }
    
    return me;
  } catch (error) {
    console.error('Error parsing user from localStorage:', error);
    return null;
  }
}

/**
 * Get current user ID from various sources
 * Checks in order: me object, session, window.__ME__
 * 
 * @returns {number|null} User ID or null
 */
export function getCurrentUserId() {
  const me = getMe();
  if (me) {
    return Number(me.id || me.userid || me.userId) || null;
  }
  
  // Fallback to window.__ME__ if available
  if (window.__ME__) {
    return Number(window.__ME__.id || window.__ME__.userid || window.__ME__.userId) || null;
  }
  
  return null;
}

/**
 * Get current tenant ID from various sources
 * Checks in order: me object, session, window.__ME__
 * 
 * @returns {number|null} Tenant ID or null
 */
export function getCurrentTenantId() {
  const me = getMe();
  if (me) {
    return Number(me.tenantId || me.tenantid || me.tenant_id) || null;
  }
  
  // Fallback to window.__ME__ if available
  if (window.__ME__) {
    return Number(window.__ME__.tenantId || window.__ME__.tenantid || window.__ME__.tenant_id) || null;
  }
  
  return null;
}

export default {
  getMe,
  getCurrentUserId,
  getCurrentTenantId,
};